import { createContext } from 'react';

const ContactFlyoutContext = createContext<{
    isStepActive: boolean;
    setIsStepActive: (value: boolean) => void;
    open: boolean;
    stepHeight?: number;
    setStepHeight: (value: number | undefined) => void;
}>({
    isStepActive: false,
    setIsStepActive: () => {},
    open: false,
    stepHeight: undefined,
    setStepHeight: () => {},
});

export default ContactFlyoutContext;
